<div class="relative group h-8 w-8 flex justify-center items-center">
    <span
        class="
        absolute 
        inset-0 
        bg-gray-500 
        rounded-full 
        opacity-0 
        group-hover:opacity-100 
        transition duration-300
        "
    >
    </span>
        <lib-app-icon  
        [icon]="icon" 
        [size]="size"
        [class]="className"
        className="cursor-pointer z-1 relative"
    />
</div>